<template>
  <b-container class="mt-4" id="printable-calender">
    <div class="row position-relative">
      <div class="col-12 text-left pl-0 pr-1">
        <h2 class="font-weight-bold calender-heading d-inline-flex">{{calenderItems.title}}</h2>
        <div class="calender-action-buttons">
          <div class="pull-left"><h2 class="font-weight-bold calender-month-year d-inline-flex">{{currentMonthName}}<span>{{selectedYear}}</span></h2></div>
          <b-button class="non-printable prev-button" @click="selectedMonthIncrementDecrement(false)" :disabled="calendarStartMonth === selectedMonth" variant="light" v-if="config.enablePrevButton && !(calendarStartMonth === calendarEndMonth)">&#60;</b-button>
          <b-button class="non-printable next-button " @click="selectedMonthIncrementDecrement(true)" :disabled="calendarEndMonth === selectedMonth" variant="light" v-if="config.enableNextButton && !(calendarStartMonth === calendarEndMonth)">&#62;</b-button>
          <b-button class="non-printable mr-1" @click="printCalender('printable-calender')" variant="light" v-if="config.enablePrintCalender">Print button</b-button>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-2 calender-days calender-days-bottom" :class="'calender-'+day.toLowerCase()" v-for="(day, index) in days" :key="'days'+index">
            {{day}}
          </div>
        </div>
      </div>
       <div class="col-2 calender" :class="index === 1 ? 'day-container-sunday' : ''" v-for="index in emptyDays" :key="'emp'+index">
        &nbsp;
      </div>
      <div class="col-2 calender" :class="dayContainerClass(index)" @click="selectedDay(items)" v-for="(items, index) in filterData" :key="index">
        <!-- {{ convertDate(items.menuDate)}} <br /> -->
        <div class="calender-date">{{index+1}}</div>
        <div class="calender-text" v-if="selectedMonth === 7 && selectedYear === 2019">
          {{items.title}}
          <span v-if="config.isShowMenuDescription" class="item-description">{{items.description}}</span>
          <div :class="!items.title && index === 0 ? 'no-border' : ''" v-for="(item, index) in items.choices" :key="index">
            {{item.title}}
            <span v-if="config.isShowItemDescription" class="item-description">{{item.description}}</span>
          </div>
        </div>
        <div class="calender-no-data" v-else>
        </div>
        <!-- <div>{{item.choices.map((val) => { return val.title })}}</div> -->
      </div>
    </div>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Moment from "moment"

export default {
  name: 'orderCalendar',
  components: {
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    calenderItems: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedMonth: 7, // Moment().month() + 1, // current Month
      selectedYear: 2019,// Moment().year(), //current year /
      days : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      calendarEndMonth: (Moment(this.calenderItems.calendarEndDate).month()+1),
      calendarStartMonth: (Moment(this.calenderItems.calendarStartDate).month()+1)
    }
  },
  mounted() {
  },
  computed: {
    filterData() {
      let days = Moment(`${this.selectedYear}-${this.selectedMonth}`, "YYYY-MM").daysInMonth()
      let data = []
      let that = this
      var index = 0
      for(var i = 1; i <= days; i++) {
        if(i == that.convertDate(that.calenderItems.menu[index].menuDate)){
          data.push(that.calenderItems.menu[index])
          index++
        } else {
          data.push({})
        }
      }
      return data
    },
    currentMonthName(){
      return Moment(`${this.selectedMonth}`, "MM").format('MMMM')
    },
    emptyDays(){
      return Moment(`${this.selectedYear}-${this.selectedMonth}-01`, "YYYY-MM-DD").day()
    }
  },
  methods: {
     dayContainerClass(index) {
      let cls = 'day-container-' + this.days[((this.emptyDays + index) % 7)].toLowerCase();
      return ((this.emptyDays + index + 1) % 7 == 0 || this.filterData.length == (index+1) ? 'calender-right-border' : '') + ' ' + cls
    },
    convertDate(input) {
      return Moment(input).format('D')
    },
    selectedMonthIncrementDecrement(incrementDecrement){
      if(incrementDecrement){
        this.selectedMonth += 1
      } else{
        this.selectedMonth -= 1
      }
      if(this.selectedMonth === 13){
        this.selectedMonth = 1
        this.selectedYear += 1
      }
      if(this.selectedMonth === 0){
        this.selectedMonth = 12
        this.selectedYear -= 1
      }
      this.$emit('getSelectedMonthData')
    },
    printCalender(divName) {
      window.print();
    },
    selectedDay(item) {
      this.$emit('selectedDayEvent', item);
    }
  }
}
</script>
<style lang="scss">
  .calender {
    padding: 0 !important;
    border-left: 1px solid #ccc !important;
    border-bottom: 1px solid #ccc !important;
    width: 14.2% !important;
    flex: 0 0 14.2% !important;
    max-width: 14.2% !important;
    .calender-date{
      float: left;
      color: red;
      font-size: 30px;
      padding: 0px 12px;
      padding-bottom: 0;
      line-height: 20px;
      padding-top: 10px;
    }
    .calender-text{
      padding: 10px;
      text-align: right;
      font-size: 14px;
      padding-top: 20px;
      div {
        border-top: 1px solid #ddd;
      }
      .item-description {
        display: block;
        white-space:pre-wrap;
        font-size: 11px;
        color: #999;
      }
      .no-border {
        border: none !important;
      }
    }
    .calender-no-data{
      min-height: 165px;
    }
  }
  .calender-right-border{
    border-right: 1px solid #ccc !important;
  }
  .calender-days {
    font-weight: 600;
    width: 14.2% !important;
    flex: 0 0 14.2% !important;
    padding: 8px 0;
  }
  .calender-days-bottom {
    border-bottom: 1px solid #ccc !important;
  }
  .calender-heading{
      font-size: 36px;
      color: #2980B9;
      span {
        font-size: 24px;
      }
  }
  .empty-days-calender{
    width: 14.2% !important;
    flex: 0 0 14.2% !important;
    border-bottom: 1px solid #ccc !important;
  }
  .calender-sunday {
      background: #2980B9;
      color: #fff;
  }
  .calender-monday {
      background: #17A187;
      color: #fff;
  }
  .calender-tuesday {
      background: #94b84c;
      color: #fff;
  }
  .calender-wednesday {
      background: #f1a00f;
      color: #fff;
  }

  .calender-thursday {
      background: #c23a2b;
      color: #fff;
  }
  .calender-friday {
      background: #55677B;
      color: #fff;
  }
  .calender-saturday {
      background: #2980B9;
      color: #fff;
  }
  .calender-action-buttons {
    float: right;
    button {
      background: #2980B9 !important;
      color: #fff !important;
    }
    .next-button{
      margin-right: 10px;
    }
    .pull-left {
      float: left;
    }
    .calender-month-year{
      font-size: 36px;
      color: #2980B9;
      margin: 0;
      display: inline-flex;
      margin-bottom: 0px;
      margin-right: 10px;
      span {
        font-size: 23px;
      }
    }
  }


  .calender.day-container-sunday {
    background: #f5f5f5; 
    .calender-date {
      color:#2980B9;
    }
  }

  .calender.day-container-monday {
    background: #fff; 
    .calender-date {
      color:#17A187;
    }
  }

  .calender.day-container-tuesday {
    background: #fff; 
    .calender-date {
      color:#94b84c;
    }
  }

  .calender.day-container-wednesday {
    background: #fff; 
    .calender-date {
      color:#f1a00f;
    }
  }

  .calender.day-container-thursday {
    background: #fff; 
    .calender-date {
      color:#c23a2b;
    }
  }

  .calender.day-container-friday  {
    background: #fff; 
    .calender-date {
      color:#55677B;
    }
  }

  .calender.day-container-saturday {
    background: #f5f5f5; 
    .calender-date {
      color:#2980B9;
    }
  }

  @media print {
    
    body {
      -webkit-print-color-adjust: exact !important;
    }
    .logo {
      width: 300px !important;
      max-width: 300px !important;
    }

    .non-printable, #nav {
      display: none;
    }

    .container {
      width: 100%;
      max-width: 100%;
    }
    .calender.day-container-sunday {
      background: #fff; 
      .calender-date {
        color:#2980B9;
      }
    }
    .calender.day-container-saturday {
      background: #fff; 
      .calender-date {
        color:#2980B9;
      }
    }
  }

  /* style sheet for "letter" printing */
  @media print and (width: 8.5in) and (height: 11in) {
    @page {
        margin: 1in;
    }
  }
</style>